import { ListItemIcon } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import OutlinedInput from '@mui/material/OutlinedInput';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { makeStyles } from '@mui/styles';

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: '20rem',
      width: '15rem',
    },
  },
};
type Props = {
  selectionItems: string[];
  placeHolder: string;
  selectedItems: string[];
  setSelectedItems: (items: any) => void;
};
export default function MultiSelector(props: Props) {
  const { selectionItems, placeHolder, selectedItems, setSelectedItems } =
    props;
  const handleChange = (event: SelectChangeEvent<typeof selectedItems>) => {
    const value = event.target.value;
    if (value[value.length - 1] === 'all') {
      setSelectedItems(
        selectedItems.length === selectionItems.length ? [] : selectionItems
      );
      return;
    }
    setSelectedItems(value);
  };
  const isAllSelected =
    selectedItems.length > 0 && selectedItems.length === selectionItems.length;
  const useStyles: any = makeStyles((theme: any) => ({
    formControl: {
      margin: theme.spacing(1),
      width: 300,
    },
    indeterminateColor: {
      color: '#f50057',
    },
    selectAllText: {
      fontWeight: 500,
    },
    selectedAll: {
      backgroundColor: 'rgba(0, 0, 0, 0.08)',
      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.08)',
      },
    },
  }));
  return (
    <>
      <FormControl fullWidth>
        <InputLabel id="demo-multiple-checkbox-label">{placeHolder}</InputLabel>
        <Select
          labelId="demo-multiple-checkbox-label"
          id="demo-multiple-checkbox"
          multiple
          value={selectedItems}
          onChange={handleChange}
          input={<OutlinedInput label={placeHolder} />}
          renderValue={(selected) => `${selected.length} Selected`}
          MenuProps={MenuProps}
          disabled={selectionItems.length === 0}
        >
          <MenuItem
            value="all"
            classes={{
              root: isAllSelected ? useStyles.selectedAll : '',
            }}
          >
            <ListItemIcon>
              <Checkbox
                classes={{ indeterminate: useStyles.indeterminateColor }}
                checked={isAllSelected}
                indeterminate={
                  selectedItems.length > 0 &&
                  selectedItems.length < selectionItems.length
                }
              />
            </ListItemIcon>
            <ListItemText
              classes={{ primary: useStyles.selectAllText }}
              primary="Select All"
            />
          </MenuItem>
          {selectionItems.map((name) => (
            <MenuItem key={name} value={name} className="flex-column">
              <div className="flex-align-center w-100">
                <Checkbox checked={selectedItems.indexOf(name) > -1} />
                <ListItemText primary={name} />
              </div>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </>
  );
}
